type SwiperArrowRightProps = {
  fill?: string;
  width?: number;
  height?: number;
} & React.SVGProps<SVGSVGElement>;

export const SwiperArrowRight: React.FC<SwiperArrowRightProps> = ({
  fill = "#EB8367",
  width = 17,
  height = 17,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.389771 8.43362C0.389771 8.69885 0.495132 8.95322 0.682679 9.14076C0.870226 9.32831 1.12459 9.43367 1.38982 9.43367L12.9771 9.43367L8.68356 13.7272C8.50691 13.9168 8.41074 14.1676 8.41531 14.4266C8.41988 14.6857 8.52484 14.9329 8.70807 15.1161C8.89129 15.2994 9.13849 15.4043 9.39757 15.4089C9.65665 15.4135 9.90739 15.3173 10.097 15.1407L16.0973 9.14033C16.2846 8.95281 16.3898 8.69863 16.3898 8.43362C16.3898 8.1686 16.2846 7.91442 16.0973 7.72691L10.097 1.72658C9.90739 1.54993 9.65665 1.45376 9.39757 1.45834C9.13849 1.46291 8.89129 1.56786 8.70807 1.75109C8.52484 1.93432 8.41988 2.18151 8.41531 2.44059C8.41074 2.69968 8.50691 2.95042 8.68356 3.14L12.9771 7.43356L1.38982 7.43356C1.12459 7.43356 0.870226 7.53893 0.682679 7.72647C0.495132 7.91402 0.389771 8.16839 0.389771 8.43362Z"
      fill={fill}
    />
  </svg>
);